import React from 'react';
import {
  UserCheck,
  Kanban,
  Sheet,
  Image as ImageIcon,
} from 'lucide-react';
import FeatureSection from './FeatureSection';

const features = [
  {
    title: 'Automated Lead Qualification',
    desc: 'The AI identifies user intent and gently guides each conversation toward your specific calls to action.',
    icon: <UserCheck size={20} />,
    bg: '#e0f7fe',
    color: '#06b6ec',
  },
  {
    title: 'Visual CRM Pipeline',
    desc: 'Track every lead from New → Contacted → Qualified → Won inside a clean, dedicated dashboard.',
    icon: <Kanban size={20} />,
    bg: '#ede9fe',
    color: '#8b5cf6',
  },
  {
    title: 'Auto-Data Mapping',
    desc: 'Extracts name, email, phone and intent right from the chat text and writes them to your Google Sheets.',
    icon: <Sheet size={20} />,
    bg: '#dcfce7',
    color: '#22c55e',
  },
  {
    title: 'Multi-Media Processing',
    desc: 'Receive and store images, videos, audio / voice messages and documents — all attached to the right lead.',
    icon: <ImageIcon size={20} />,
    bg: '#ffedd5',
    color: '#f97316',
  },
];

export default function LeadCRM() {
  const visual = (
    <div className="kanbanCard">
      <div className="kanbanCard__col">
        <div className="kanbanCard__head"><span className="dot dot--blue" /> New</div>
        <div className="kanbanCard__item">Wei Chen · WhatsApp</div>
        <div className="kanbanCard__item">Mei Lin · IG</div>
        <div className="kanbanCard__item">+ 12 more</div>
      </div>
      <div className="kanbanCard__col">
        <div className="kanbanCard__head"><span className="dot dot--yellow" /> Qualified</div>
        <div className="kanbanCard__item">Jun Wong · Web</div>
        <div className="kanbanCard__item">Hui Tan · WA</div>
      </div>
      <div className="kanbanCard__col">
        <div className="kanbanCard__head"><span className="dot dot--green" /> Won</div>
        <div className="kanbanCard__item kanbanCard__item--won">Xin Lim · RM 4,200</div>
        <div className="kanbanCard__item kanbanCard__item--won">Bao Yu · RM 1,950</div>
      </div>
    </div>
  );

  return (
    <FeatureSection
      id="crm"
      eyebrow="Lead Generation · CRM"
      title="Turn every chat into a closed deal"
      description="AINA isn't just a chatbot — it's a 24/7 sales rep that qualifies, captures and tracks every opportunity into a visual pipeline."
      features={features}
      variant="light"
      visual={visual}
    />
  );
}
